const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function trendingReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_TRENDING':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_LIST_TRENDING':
			return {
				...state,
				list: action?.payload?.trendings || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default trendingReducer;
